import ESContext from "../ESContext";
import AnalyticsUtil from "../graphs/AnalyticsUtil";
import {YAxisFormatTime} from "../graphs/GraphFormatting";
import {formatGermanDate, formatSeconds} from "../../common/TimeUtil";
import HighChartsGraph from "../graphs/HighChartsGraph";
import CachedGraphV2 from "../graphs/CachedGraphV2";
import OutlierUtil from "../OutlierUtil";
import StatisticsUtil from "../StatisticsUtil";

class SessionLength_Daily {
    static getUUID() {
        return "f135924d-7a1b-41d8-875d-b9ae771adcef";
    }

    static getProps() {
        return [
            {id:"title",name:"Title", type:"string"},
            {id:"group",name:"Group by", type:"string"},
            {id:"filterOutlier", name: "Filter Outlier", type:"boolean"},
            {id:"filter",name:"Filter", type:"filterTags"}
        ];
    }

    static getGraphSize() {
        return 1;
    }

    static getHeightRatio() {
        return "50%";
    }

    static calcSessionLength(_dauData, _filterOutlier, _groupName, _groupValue) {
        let dauData = _dauData;
        if (_groupName && _groupValue) {
            dauData = AnalyticsUtil.filterBy(_dauData, (_e) => _e[_groupName] === _groupValue);
        }
        let series = [];
        if (_filterOutlier) {
            let data = {};
            for (let i = 0; i < dauData.length; i++) {
                const current = dauData[i];
                if (!data[current.day]) {
                    data[current.day] = [];
                }
                data[current.day].push(current.duration);
            }
            for(let day in data) {
                let sessionLengths = data[day];
                let outlierResult = OutlierUtil.filterOutlier(sessionLengths);
                let avg = StatisticsUtil.avg(outlierResult.cleaned);
                let outlierPercentage = outlierResult.outlier.length / (outlierResult.outlier.length + outlierResult.cleaned.length);
                const outlierText = "Outliers: "+outlierResult.outlier.length+"("+Math.round(outlierPercentage*10000)/100+"%)";
                series.push({name: _groupValue, x: new Date(day).getTime(), y: avg, text: formatSeconds(avg)+ " ("+outlierResult.cleaned.length+" Users) "+outlierText});
            }
        } else {
            for (let i = 0; i < dauData.length; i++) {
                const current = dauData[i];
                const sessionLengthPerUser = current.duration / current.dau;
                series.push({name: _groupValue, x: new Date(current.day).getTime(), y: sessionLengthPerUser, text: formatSeconds(sessionLengthPerUser)+ " ("+current.dau+" Users)"});
            }
        }
        return {name: _groupValue, data: series};
    }

    static getGraphData(ctx, _props, _cb) {
        let filter = JSON.parse(JSON.stringify(_props.filter));
        if (_props.dateSelection) {
            filter.day = {from: _props.dateSelection.start, to: _props.dateSelection.end};
        }
        const grouping = ["day", _props.group];
        if (_props.filterOutlier === true) {
            grouping.push("user_id");
        }
        ctx.sendAsync("dau","session_duration_v4",["cardinality:user_id:dau","sum:duration:duration"],grouping, filter);
        return ctx.waitForCompletion((_err, _data) => {
            if (_err) {
                _cb(_err);
            } else {
                let dauData = _data.dau.result;
                let groups = AnalyticsUtil.getDistinct(dauData, _props.group);
                let series = [];
                if (groups.length > 0) {
                    for(let i = 0; i < groups.length; i++) {
                        let data = SessionLength_Daily.calcSessionLength(dauData, _props.filterOutlier, _props.group, groups[i]);
                        series.push(data);
                    }
                } else {
                    let data = SessionLength_Daily.calcSessionLength(dauData, _props.filterOutlier);
                    series.push(data);
                }
                let graphData = {
                    chart : {type: "line"},
                    legend: {enabled: groups.length > 1},
                    series : series,
                };
                return _cb(null, graphData);
            }
        });
    }

    static getXAxis() {
        return {type: "datetime", crosshair: true};
    }

    static getYAxis() {
        return YAxisFormatTime();
    }

    static getTooltip() {
        return {
            split:true,
            formatter : function() {
                let result = [formatGermanDate(new Date(this.x))];
                for(let i = 0; i < this.points.length; i++) {
                    result.push(this.points[i].point.text);
                }
                return result;
            }
        };
    }
}

export default CachedGraphV2(SessionLength_Daily, HighChartsGraph);